export default __webpack_public_path__ + "static/media/whatsApp-Logo.422550d7.svg";